import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { SignaturePadComponent } from '@almothafar/angular-signature-pad';

@Component({
  selector: 'app-signature-field',
  templateUrl: './signature-field.component.html',
  styleUrls: ['./signature-field.component.css'],
})
export class SignatureFieldComponent implements AfterViewInit, OnChanges {
  @Input() value: string | null = null;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string>();

  @ViewChild('pad', { static: false }) pad?: SignaturePadComponent;

  padOptions: any = {
    minWidth: 1,
    maxWidth: 2.5,
    penColor: 'rgb(20, 40, 90)',
    backgroundColor: 'rgb(255, 255, 255)',
    canvasWidth: 600,
    canvasHeight: 180,
  };

  private restoredFor: string | null = null;

  ngAfterViewInit(): void {
    this.applyDisabled();
    this.restore();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] && !changes['disabled'].firstChange) {
      this.applyDisabled();
    }
    if (changes['value'] && !changes['value'].firstChange) {
      this.restoredFor = null;
      this.restore();
    }
  }

  onDrawEnd(): void {
    if (!this.pad || this.pad.isEmpty()) {
      return;
    }
    const url = this.pad.toDataURL();
    this.restoredFor = url;
    this.valueChange.emit(url);
  }

  clear(): void {
    this.pad?.clear();
    const canvas = this.pad?.getCanvas();
    if (canvas) {
      canvas.getContext('2d')?.clearRect(0, 0, canvas.width, canvas.height);
    }
    this.restoredFor = null;
    this.valueChange.emit('');
  }

  get hasPreview(): boolean {
    return !!this.value && this.value.startsWith('data:image');
  }

  private restore(): void {
    if (!this.pad || !this.value || this.restoredFor === this.value) {
      return;
    }
    if (!this.pad.isEmpty()) {
      return;
    }
    try {
      this.pad.fromDataURL(this.value);
      this.restoredFor = this.value;
    } catch {
    }
  }

  private applyDisabled(): void {
    if (!this.pad) {
      return;
    }
    if (this.disabled) {
      this.pad.off();
    } else {
      this.pad.on();
    }
  }
}
